import { Stack, Text, Title } from '@mantine/core';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import Spinner from '../components/Spinner';

const RootPage = () => {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);

  const roles = user?.userRoles;
  const hasAccount = Boolean(roles && roles.length > 0 && roles[0].account);

  useEffect(() => {
    let componentUnmounted = false;

    if (componentUnmounted) {
      return;
    }

    if (!user) {
      navigate('/login');
      return;
    }

    if (hasAccount) {
      const account = user.userRoles[0].account;
      const domain = account.domains[0];
      navigate(`/accounts/${account.id}/domains/${domain.id}/analytics`);
    }

    return () => {
      componentUnmounted = true;
    };
  }, [user, hasAccount, navigate]);

  if (user && !hasAccount) {
    return (
      <Stack align="center" mt="xl" gap="xs">
        <Title order={3}>No account assigned</Title>
        <Text c="dimmed">Your user is not assigned to any account. Please contact your administrator.</Text>
      </Stack>
    );
  }

  return <Spinner />;
};

export default RootPage;
